export default {
  analytics: {
    google_conversion_id: '943617023',
    google_analytics_sandbox_id: 'UA-11834194-31'
  },
  google_tag_manager_id: 'GTM-585RXMV',
  google_optimize_container_id: 'GTM-5VPWWP',
  ui: {
    default_user_image_path: '/images/default-user.jpg',
    item_list_views: [
      {
        value: 'list',
        label: 'List'
      },
      {
        value: 'grid',
        label: 'Grid'
      }
    ],
    item_small_preview_paths: [
      'icon_with_landscape_preview.icon_url',
      'icon_with_square_preview.icon_url',
      'icon_with_video_preview.icon_url',
      'icon_with_audio_preview.icon_url',
      'icon_with_thumbnail_preview.icon_url',
      'thumbnail_preview.small_url',
      'icon_preview.icon_url'
    ],
    featured_hero_item_viewtype: 'list'
  },
  common: {
    search_page_size: 30,
    max_pages_count: 60
  },
  features: {
    /**
     * @description Decide whether to show sign up modal or render the sign up page.
     * @author Fraser Xu
     * @expires
     */
    'modal:signup': false,

    /**
     * @description
     * @author
     * @expires
     */
    'shopfront-api': false,

    /**
     * @description Decide whether to display v0 or v1 item cards in featured/popular items page.
     * @author Pawel Galazka
     * @expires When all markets will use v1 item card
     */
    'v0-featured-page': false
  },
  assets_domains: {
    main: 'd2mdw063ttlqtq.cloudfront.net',
    main_alias: '0.s3.envato.com',
    user_profile: 'user-profile.s3.envato.com'
  },
  asset_type: 'item',
  search_query: {
    default_sort_by: 'date',
    default_sort_by_options: [
      {
        label: 'Best match',
        value: 'relevance'
      },
      {
        label: 'Trending items',
        value: 'trending'
      },
      {
        label: 'Best sellers',
        value: 'sales'
      },
      {
        label: 'Best rated',
        value: 'rating'
      },
      {
        label: 'Newest items',
        value: 'date'
      },
      {
        label: 'Price: low to high',
        value: 'price-asc'
      },
      {
        label: 'Price: high to low',
        value: 'price-desc'
      }
    ]
  },
  recommendations_limit: 8,
  show_category_in_selected_filters: false,
  min_price: 100,
  homepage: {
    newest_items_page_size: 40,
    newest_items_square: true
  }
}
